import React, { useEffect, useRef, useState } from "react";
import {
  ChevronLeft,
  ChevronRight,
  ExternalLink,
  Github,
} from "lucide-react";

const proyectos = [
  {
    id: 1,
    titulo:
      "Dashboard Prime para sistema MES (Sistema de Ejecución de Manufactura)",
    descripcion:
      "Desarrollé una aplicación web con React y Material UI (MUI), integrando una API para visualizar un resumen de los datos correspondientes a las distintas líneas de producción de la planta de Scania Tucumán.",
    imagenes: ["dashboard1.png", "dashboard2.png"],
    confidencial: true,
  },
  {
    id: 2,
    titulo: "Lineboard Web para sistema MES",
    descripcion:
      "Desarrollé una aplicación web con React y Material UI (MUI), integrando una API y comunicación mediante MQTT para visualizar en tiempo real y de forma detallada los datos, estado y avance de cada línea de producción de la planta de Scania Tucumán.",
    imagenes: ["lineboard1.png", "lineboard2.png"],
    confidencial: true,
  },
  {
    id: 3,
    titulo: "Advance Soccer Training",
    descripcion:
      "Realicé un sitio web con React y CSS, logrando una identidad digital más sólida para la empresa. Integré todas sus páginas externas y herramientas existentes en un único lugar, creando un sitio web práctico, claro y con la información organizada de manera eficiente, lo que facilita la navegación y mejora la experiencia de los usuarios. Además, implementé i18n para que el sitio pueda visualizarse tanto en español como en inglés.",
    imagenes: [
      "AST1.png",
      "AST2.png",
      "AST3.png",
      "AST4.png",
      "AST5.png",
      "AST6.png",
      "AST7.png",
    ],
    sitioWeb: "https://advancesoccertraining.com/",
  },
  {
    id: 4,
    titulo: "Gimnasio",
    descripcion:
      "Desarrollé una página web para un gimnasio ficticio utilizando React y Tailwind CSS, que incluye toda la información esencial del gimnasio: horarios, perfiles de entrenadores, precios de los planes, detalle de cada clase y una tienda para encargar prendas. Cuenta con un diseño responsive y una navegación clara e intuitiva, pensada para brindar una excelente experiencia al usuario.",
    imagenes: [
      "GYM1.png",
      "GYM2.png",
      "GYM3.png",
      "GYM4.png",
      "GYM5.png",
      "GYM6.png",
      "GYM7.png",
      "GYM8.png",
    ],
    sitioWeb: "https://pagina-web-gym.vercel.app/",
  },

  /*
  {
    id: 5,
    titulo: "Taylor Swift",
    descripcion:
      "Desarrollé un sitio web inspirado en el universo de Taylor Swift con secciones de Home, Merch, Albums y Tour. Implementado con React y CSS, el proyecto destaca por su catálogo de productos, discografía con enlaces a plataformas y un calendario interactivo de The Eras Tour, ofreciendo una experiencia de usuario clara, atractiva y fácil de navegar.",
    imagenes: [
      "TS1.png",
      "TS2.png",
      "TS3.png",
      "TS4.png",
    ],
    repositorio:
      "https://github.com/mauricioferlicc/Taylor-Swift-Sitio-Web.git",
    sitioWeb: "https://taylor-swift-sitio-web.vercel.app/",
  },
  */

  /*
  {
    id: 6,
    titulo: "Panadería",
    descripcion:
      "Desarrollé una página web para una panadería ficticia con catálogo de productos, carrito de compras, buscador interactivo y enlaces a redes sociales. Incluye carrusel de imágenes y secciones organizadas en panificación y repostería. Implementado con React y CSS.",
    imagenes: [
      "PANADERIA1.png",
      "PANADERIA2.png",
      "PANADERIA3.png",
    ],
    repositorio:
      "https://github.com/mauricioferlicc/Panaderia-Pagina-Web.git",
    sitioWeb: "https://panaderia-pagina-web.vercel.app/",
  },
  */
];

const ProyectoCard = ({ proyecto, index, visible }) => {
  const [imagenActual, setImagenActual] = useState(0);

  const cambiarImagen = (direccion) => {
    setImagenActual((actual) => {
      const nueva = actual + direccion;

      if (nueva < 0) return proyecto.imagenes.length - 1;
      if (nueva >= proyecto.imagenes.length) return 0;

      return nueva;
    });
  };

  return (
    <article
      className={`proyecto-animacion ${
        visible ? "proyecto-visible" : ""
      }`}
      style={{
        animationDelay: `${0.2 + index * 0.12}s`,
      }}
    >
      <div className="overflow-hidden rounded-[30px] border-2 border-[#1c2143] bg-transparent p-5 shadow-[0_20px_60px_rgba(28,33,67,0.15)] backdrop-blur-[20px] transition duration-300 hover:-translate-y-1 hover:shadow-[0_0_40px_rgba(28,33,67,0.25)] sm:p-10">
        <div className="relative overflow-hidden rounded-[20px]">
          <img
            src={proyecto.imagenes[imagenActual]}
            alt={proyecto.titulo}
            className="h-[162px] w-full object-cover transition duration-500 sm:h-[568px]"
          />

          {proyecto.imagenes.length > 1 && (
            <>
              <button
                onClick={() => cambiarImagen(-1)}
                className="absolute left-2 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border-2 border-[#1c2143] bg-white/90 text-[#1c2143] backdrop-blur-md transition duration-300 hover:bg-[#1c2143] hover:text-white sm:left-4 sm:h-12 sm:w-12"
                aria-label="Imagen anterior"
              >
                <ChevronLeft size={22} />
              </button>

              <button
                onClick={() => cambiarImagen(1)}
                className="absolute right-2 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border-2 border-[#1c2143] bg-white/90 text-[#1c2143] backdrop-blur-md transition duration-300 hover:bg-[#1c2143] hover:text-white sm:right-4 sm:h-12 sm:w-12"
                aria-label="Imagen siguiente"
              >
                <ChevronRight size={22} />
              </button>
            </>
          )}
        </div>

        {proyecto.imagenes.length > 1 && (
          <div className="mt-4 flex justify-center gap-2 sm:mt-5">
            {proyecto.imagenes.map((_, index) => (
              <button
                key={index}
                onClick={() => setImagenActual(index)}
                className={`h-3 w-3 rounded-full transition-all ${
                  index === imagenActual
                    ? "scale-125 bg-[#1c2143]"
                    : "bg-[#1c2143]/25 hover:bg-[#1c2143]/50"
                }`}
                aria-label={`Imagen ${index + 1}`}
              />
            ))}
          </div>
        )}

        <div className="px-1 pt-3 sm:px-2 sm:pb-4 sm:pt-2">
          <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-center">
            <h3 className="text-[20px] font-black text-[#1c2143] sm:text-3xl">
              {proyecto.titulo}
            </h3>

            {proyecto.proximamente && (
              <span className="w-fit rounded-full border-2 border-[#1c2143] bg-[#1c2143]/10 px-4 py-2 text-sm font-semibold text-[#1c2143]">
                Próximamente
              </span>
            )}
          </div>

          <p className="mt-2 text-base leading-7 text-black sm:mt-5 sm:text-lg sm:leading-8">
            {proyecto.descripcion}
          </p>

          <p className="mt-4 text-sm font-semibold text-[#2f5972]">
            {proyecto.tecnologias}
          </p>

          <div className="mt-0 flex flex-col items-stretch gap-4 sm:mt-7 sm:flex-row sm:flex-wrap sm:items-center">
            {proyecto.sitioWeb && (
              <a
                href={proyecto.sitioWeb}
                target="_blank"
                rel="noreferrer"
                className="flex items-center justify-center gap-2 rounded-full bg-[#1c2143] px-6 py-3 font-bold text-white transition duration-300 hover:-translate-y-1 hover:bg-[#2f5972]"
              >
                Visitar
                <ExternalLink size={18} />
              </a>
            )}

            {proyecto.confidencial && (
              <p className="text-base font-medium leading-6 text-[#2f5972] sm:text-lg">
                Por motivos de confidencialidad, no es posible mostrar la
                aplicación funcionando ni su contenido original.
                <br />
                Las imágenes fueron editadas para preservar la información de
                la empresa.
              </p>
            )}

            {proyecto.github && (
              <a
                href={proyecto.github}
                target="_blank"
                rel="noreferrer"
                className="flex items-center justify-center gap-2 rounded-full border-2 border-[#1c2143] bg-transparent px-6 py-3 font-bold text-[#1c2143] transition duration-300 hover:-translate-y-1 hover:bg-[#1c2143] hover:text-white"
              >
                GitHub
                <Github size={18} />
              </a>
            )}
          </div>
        </div>
      </div>
    </article>
  );
};

const Proyectos = () => {
  const [visible, setVisible] = useState(false);
  const seccionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.05,
      }
    );

    if (seccionRef.current) {
      observer.observe(seccionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="proyectos"
      ref={seccionRef}
      className="px-4 py-0 sm:px-6"
    >
      <div className="mx-auto max-w-[1230px] pb-20">
        <h2
          className={`proyecto-titulo-animacion ${
            visible ? "proyecto-titulo-visible" : ""
          } relative mb-5 text-center text-[35px] font-black text-[#1c2143] sm:text-[50px]`}
        >
          Proyectos

          <span className="mx-auto block h-1 w-[90px] rounded-full bg-[#1c2143] sm:w-[120px]" />
        </h2>

        <div className="space-y-10">
          {proyectos.map((proyecto, index) => (
            <ProyectoCard
              key={proyecto.titulo}
              proyecto={proyecto}
              index={index}
              visible={visible}
            />
          ))}
        </div>
      </div>

      <style>
        {`
          @keyframes aparecerDesdeAbajo {
            from {
              opacity: 0;
              transform: translateY(50px);
            }

            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .proyecto-animacion,
          .proyecto-titulo-animacion {
            opacity: 0;
          }

          .proyecto-visible,
          .proyecto-titulo-visible {
            animation: aparecerDesdeAbajo 0.8s ease-out forwards;
          }

          .proyecto-titulo-visible {
            animation-delay: 0.1s;
          }

          @media (prefers-reduced-motion: reduce) {
            .proyecto-animacion,
            .proyecto-titulo-animacion {
              opacity: 1;
            }

            .proyecto-visible,
            .proyecto-titulo-visible {
              animation: none;
            }
          }
        `}
      </style>
    </section>
  );
};

export default Proyectos;